import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from './ListPaginated';
import Create from './Create';
import Edit from './Edit';

export default function PromoCodesBatch() {
  return (
    <Switch>
      <Route path="/app/promoCodeBatches/create/" exact component={Create} />
      <Route path="/app/promoCodeBatches/:promoCodeBatchId/" component={Edit} />
      <Route path="/app/promoCodeBatches/" component={List} />
    </Switch>
  );
}
